<template>
  <div style="width: 100%; height: 100%">
    <template v-if="!isSlot">
      <div class="bannerBox">
        <el-upload
          class="bannerImg"
          :action="$api.api.uploadImg"
          name="file"
          :show-file-list="false"
          :before-upload="beforeUploadFn"
          :http-request="uploadFn"
          :on-success="bannerSuccess"
        >
          <template>
            <img v-if="image != $api.urls && image" :src="image" class="avatar" />
            <div style="text-align: center; color: #888" v-else>
              <i class="el-icon-camera avatar-uploader-icon"></i>
              <span style="text-align: center; font-size: 12px">上传图片</span>
            </div>
          </template>
        </el-upload>
      </div>
    </template>

    <div v-if="isSlot">
      <el-upload
        :action="$api.api.uploadImg"
        name="file"
        :show-file-list="false"
        :before-upload="beforeUploadFn"
        :http-request="uploadFn"
        :on-success="bannerSuccess"
      >
        <slot></slot>
      </el-upload>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    infoList: {
      type: Object,
      default: function () {
        return {
          photos: "",
        };
      },
    },
    image: {
      type: String,
      default: "",
    },
    paramObj: {
      type: Object,
      default: function () {
        return {};
      },
    },
    isSlot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      no: "1",
    };
  },
  created() {},
  computed: {},
  methods: {
    beforeUploadFn: function (res) {
      var no = new Date(new Date()).valueOf() + "_" + Math.round(Math.random() * 1000);
      this.no = no;
    },

    // 上传图片
    uploadFn: function (res) {
      var no = new Date(new Date()).valueOf() + "_" + Math.round(Math.random() * 1000);
      var files = res.file;
      var form = new FormData();
      console.log(files, 99999999);
      form.append("file", files);
      form.append("no", no);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      this.$https(this.$api.api.uploadImg, form, "POST").then((res) => {
        if (res.data.code == 0 || res.data.status == 1) {
          // this.$set(this.infoList, "photos", res.data.path);
          //  判断是否传参数
          var paramObj = JSON.stringify(this.paramObj);
          if (paramObj == "{}") {
            this.$emit("getImg", res.data.data.path);
          } else {
            this.$emit("getImg", this.paramObj, res.data.data.path);
          }
        }
      });

      // axios.post(that.uploadUrl, fd,config).then( res => {
      // console.log(res)
      // }).catch( res => {
      // console.log(res)
      // })
    },

    // 图片上传
    bannerSuccess: function (res) {
      if (res.code == 0) {
        // this.$set(this.infoList, "photos", res.data.path);
        //  判断是否传参数
        var paramObj = JSON.stringify(this.paramObj);
        if (paramObj == "{}") {
          this.$emit("getImg", res.data.data.path);
        } else {
          this.$emit("getImg", this.paramObj, res.data.daata.path);
        }
      } else if (res.code == 202) {
        const loading = this.$loading({
          lock: true,
          text: "登录过期，请重新登陆",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        setTimeout(() => {
          loading.close();
          this.$router.replace({
            path: "/Login",
          });
        }, 2000);
      }
    },
  },
};
</script>

<style lang="less">
.bannerBox {
  width: 100%;
  height: 100%;

  .bannerImg {
    width: 100%;
    height: 100%;
  }

  .el-upload {
    width: 100%;
    height: 100%;
    line-height: 100%;
    border: 1px dashed #ccc;
    background: #f5f7f9;
    margin: auto;
    text-align: center;
    font-size: 25px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }

    i {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elUpload.vue